import { type NextSeoProps } from 'next-seo';
import { useRoomHostName } from '../useRoomHostName';
import { useIntl } from '@doxyme/locale';
import { useAppSelector } from '../../hooks/useReduxToolkit';
import { getWaitingRoom } from '../../features/waitingRoom/waitingRoom.selectors';
import { usePatientPaidStatus } from '../../hooks/usePatientPaidStatus';

export const useWaitingRoomSeo = (): NextSeoProps => {
  const room = useAppSelector(getWaitingRoom);
  const { freeOrPaid } = usePatientPaidStatus(room);

  const provider = useRoomHostName(room);

  const { formatMessage } = useIntl();

  const roomUrl = `${window.location.origin}/${room.slug}`;

  return {
    title: formatMessage({ id: 'patient.meta.title' }, { provider }),
    description: formatMessage(
      { id: 'patient.meta.description' },
      { provider },
    ),
    openGraph: {
      type: 'website',
      images: [{ url: `${window.location.origin}/assets/images/og-image.jpg` }],
      url: roomUrl,
      title: formatMessage(
        {
          id: `patient.meta.og.title.${freeOrPaid}`,
        },
        { provider },
      ),
      description: formatMessage(
        {
          id: `patient.meta.og.description.${freeOrPaid}`,
        },
        { roomUrl },
      ),
    },
    twitter: {
      cardType: 'summary_large_image',
    },
    noindex: true,
    nofollow: true,
  };
};
